module.exports = __webpack_public_path__ + "img/zd7.a5645715.png";